import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorSpotGrid = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill={getTheme(props["data-theme"])}
      d="M2.25 5A.75.75 0 0 1 3 4.25h18a.75.75 0 0 1 0 1.5H3A.75.75 0 0 1 2.25 5Zm0 14a.75.75 0 0 1 .75-.75h18a.75.75 0 0 1 0 1.5H3a.75.75 0 0 1-.75-.75ZM4.635 8.6a.75.75 0 1 0-1.27.8l2.13 3.38a.75.75 0 1 0 1.269-.799l-2.13-3.38Zm13.2 1.501a.75.75 0 0 0-1.145.97l3.738 4.414a.75.75 0 1 0 1.145-.97l-3.738-4.414Zm-9.677 3.83a.75.75 0 0 0-1.221.871l.453.634a.75.75 0 1 0 1.22-.872l-.452-.634Z"
    />
    <path
      fill="#F7A600"
      d="M15.783 7.756a.75.75 0 1 0-1.129.988l.438.5a.75.75 0 1 0 1.129-.988l-.438-.5Zm-1.642 3.092a.75.75 0 1 0-1.082-1.04l-3.15 3.278a.75.75 0 0 0 1.08 1.04l3.152-3.278Z"
    />
  </svg>
);
export default SvgTwoColorSpotGrid;
